import React from "react"
import styled from "styled-components"
import ArrowedLink from "../Links/ArrowedLink"
import { P, SubTitle } from "../styles/TextStyles.styled"
import dark from "../../theme/dark"
import ImageCarouselItem from "./ImageCarouselItem"
import Avatar from "../Avatar"
import { graphql, useStaticQuery, navigate } from "gatsby"
import { DomainAwareThemeProvider } from "../DomainAwareThemeProvider"

const CardAvatar = styled(Avatar)`
  margin-top: 16px;
  margin-bottom: -4px;
`

const ProjectCardCarouselItem = ({ reference, item, isDesktop, ...props }) => {
  const { allDatoCmsTranslation } = useStaticQuery(graphql`
    {
      allDatoCmsTranslation {
        edges {
          node {
            learnMore
          }
        }
      }
    }
  `)
  const isInternalLink = item.url?.startsWith("/")
  const labels = allDatoCmsTranslation.edges.find(
    edge => edge.node.locale === item.locale
  ).node
  return (
    <ImageCarouselItem
      {...item}
      reference={reference}
      {...props}
      onClick={() =>
        isInternalLink ? navigate(item.url) : window.open(item.url, "_blank")
      }
      animateImageOnHover
    >
      <DomainAwareThemeProvider theme={dark}>
        <SubTitle css={{ fontWeight: "bold" }}>{item.title}</SubTitle>
        {isDesktop && item.author && <CardAvatar {...item.author} />}
        {isDesktop && <P>{item.description}</P>}
        {item.url && (
          <ArrowedLink
            onClick={e => e.stopPropagation()}
            hideBackground={true}
            link={{
              url: item.url,
              label: labels.learnMore,
              external: !isInternalLink,
            }}
          />
        )}
      </DomainAwareThemeProvider>
    </ImageCarouselItem>
  )
}

export default React.forwardRef((props, ref) => {
  return <ProjectCardCarouselItem {...props} reference={ref} />
})
